import { type Ref } from 'vue'

type State = 'idle' | 'paused' | 'dragging' | 'resuming'

interface UseMarqueePauseOptions {
  state: Ref<State>
  pauseScroll: () => void
  resumeScroll: () => void
}

interface UseMarqueePauseReturn {
  onPointerEnter: () => void
  onPointerLeave: () => void
  onFocusIn: () => void
  onFocusOut: () => void
}

export function useMarqueePause(
  options: UseMarqueePauseOptions,
): UseMarqueePauseReturn {
  const { state, pauseScroll, resumeScroll } = options
  let focusCount = 0

  function onPointerEnter() {
    if (state.value !== 'idle') return
    state.value = 'paused'
    pauseScroll()
  }

  function onPointerLeave() {
    if (state.value === 'dragging') return

    if (state.value === 'resuming') return

    if (state.value === 'paused' && focusCount === 0) {
      state.value = 'idle'
      resumeScroll()
    }
  }

  function onFocusIn() {
    focusCount += 1
    if (state.value === 'idle') {
      state.value = 'paused'
      pauseScroll()
    }
  }

  function onFocusOut() {
    focusCount = Math.max(0, focusCount - 1)
    if (state.value === 'paused' && focusCount === 0) {
      state.value = 'idle'
      resumeScroll()
    }
  }

  return {
    onPointerEnter,
    onPointerLeave,
    onFocusIn,
    onFocusOut,
  }
}
